function e(e){const[n,r]=/schema\/([\w-]+)\/([\w\.\-]+)\.json$/g.exec(e).slice(1,3);return{library:n,version:r}}export{e as default};
//# sourceMappingURL=parser.modern.js.map
